import request from 'superagent';
const ROOT_URL = process.env.API_URL;
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values, dispatch, props, field) => {

    if (field === 'email') {
        return request('GET', ROOT_URL + '/emails/verification/' + values.email).then(function(result) {
        }, function(err) {
            throw { email: 'El email no es válido.', _error: 'Revisá los campos indicados.'}
        });
    }

    if (field === 'area_code') {
        return request('GET', ROOT_URL + '/area_codes/_code/' + values.area_code).then(function(result) {

        }, function(err) {
            throw { area_code: 'El código de área no es válido.', _error: 'Revisá los campos indicados.'}
        });
    }

    if (field === 'number') {
        if (values.area_code && values.number) {
            return request('GET', ROOT_URL + '/subscribers/_check/' + values.area_code + values.number).then(function(result) {
            }, function(err) {
                throw { number: 'El número no es válido.', _error: 'Revisá los campos indicados.'}
            });
        }
    }
    return sleep(1);
}

export default asyncValidate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/asyncValidationsMainForm.js
 **/